import AdminApi from '../services/api';
import swal from 'sweetalert2';
import session from "../services/session";

/* init */

const AdminApiService = new AdminApi()

export default{

    props: ['show', 'vacation'],

    data() {
        return {
            title: '',
            buttonName: 'Odbij',
            isLoading: false,
            selectedVacation: null,
            declineReason: '',
            hasError: '',
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val === true){
                this.selectedVacation = this.vacation;
                this.title = 'Odbijanje godisnjeg';

            }
        },
    },

    methods: {
        close() {
            this.$topnavbar.$emit('closeDeclineVacation')
            this.reset();
        },
        successUpdate(){
            this.$topnavbar.$emit('successDeclineVacation')
        },

        decline: decline,
        reset: reset,
    },
    beforeMount() {

    },

}



function decline() {
    let _self =this;
    _self.isLoading = true;
    AdminApiService.updateVacation(_self.selectedVacation.id, "REJECTED",_self.declineReason)
        .then((response) => {
            _self.reset();
            _self.successUpdate();
        })
        .catch((error) => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


function reset() {
    this.declineReason = '';
}





// WEBPACK FOOTER //
// ./src/modals/DeclineVacationModal.js